import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { PushNotifications } from '@capacitor/push-notifications';
import { addActorDevice, storePlans } from './ApiTasks';

const checkTokenPushed = async (val) => {
  try {
    const deviceToken = localStorage.getItem('deviceToken');

    if (!deviceToken || deviceToken !== val) {
      await addActorDevice(val);
      localStorage.setItem('deviceToken', val);
    }
  } catch (error) {
    console.error('Error checking or pushing token:', error);
  }
};

const registrationListener = (token) => {
  checkTokenPushed(token.value);
};

const registrationErrorListener = (error) => {
  console.error('Error on registration:', error);
};

const pushNotificationListener = (notification) => console.log('Push received:', notification);

const isIosOrAndroid = () =>
    Capacitor.getPlatform() === 'ios'
    || Capacitor.getPlatform() === 'android';

const requestNotificationPermission = async () => {
  if (isIosOrAndroid()) {
    const info = await Device.getInfo();
    const isAndroid13OrHigher = info.platform === 'android'
      && parseInt(info.osVersion.split('.')[0], 10) >= 13;

    if (isAndroid13OrHigher) {
      const result = await PushNotifications.requestPermissions();

      if (result.receive === 'granted') {
        PushNotifications.register();
      } else {
        alert(
          'This app requires notification permissions to function correctly.'
          + ' Please enable notifications in your device settings.',
        );
      }
    } else {
      PushNotifications.register();
    }
  }
};

const addListeners = (onPushNotificationTapped) => {
  const pushNotificationActionListener = (notification) => {
    const { jobId, scheduledFor } = notification.notification.data;

    storePlans(scheduledFor, 1).then((result) => {
      if (result) {
        onPushNotificationTapped(`/job/${jobId}`);
      }
    });
  };

  if (isIosOrAndroid()) {
    PushNotifications.addListener('registration', registrationListener);
    PushNotifications.addListener('registrationError', registrationErrorListener);
    PushNotifications.addListener('pushNotificationReceived', pushNotificationListener);
    // Event triggers when a user taps on a notification.
    PushNotifications.addListener('pushNotificationActionPerformed', pushNotificationActionListener);
  }
};

export const listenForPushNotifications = (onPushNotificationTapped) => {
  requestNotificationPermission();
  addListeners(onPushNotificationTapped);
};
